var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-results"},[_c('toggle-header',{staticClass:"mb-n3"}),_c('results'),_c('canvas',{staticClass:"d-none",attrs:{"id":"canvas","width":"954","height":"370"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }